import ProjectColorText from '@ui/text/text/project-color-text';

const ViewStatsContent = () => {
  return (
    <ProjectColorText includeOpacity={false} contrastAgainstAppBackground className="L2 radius-4 padding-h-2">
      View Stats
    </ProjectColorText>
  );
};

export default ViewStatsContent;
